import { Backdrop, Button, Paper, styled } from "@mui/material";
import React from "react";
import colors from "../../../theme/themeConstants";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  handleUnfollow: () => void;
}

const UnfollowPopup = ({ isOpen, togglePopup, handleUnfollow }: IProps) => {

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent) => {
    handleStopPropagation(event);
    togglePopup();
  };

  return (
    <Backdrop open={isOpen} id={"popupOpen"}
      sx={{
        zIndex: 200
      }}
      onClick={handleClose}
    >
      <Paper onClick={handleStopPropagation} sx={{
        height: "auto",
        margin: "0 1rem",
        borderRadius: "24px",
        padding: "2rem 1rem 0 1rem",
        "p": {
          textAlign: "center"
        },
        "@media screen and (min-width: 1170px)": {
          maxWidth: "25vw",
        }
      }}>
        <p>If you unfollow, content from this niche will no longer appear in your feed.</p>
        <UnFollowButton
          onClick={handleUnfollow}
          variant="outlined"
          fullWidth
        > Unfollow </UnFollowButton>

        <Button onClick={togglePopup} fullWidth sx={{
          border: "none",
          color: "black",
          textDecoration: "underline",
          background: "transparent",
          marginBottom: "1.5rem",
          ":hover": {
            border: "none",
            background: "none",
          }
        }}>
          Cancel
        </Button>
      </Paper>
    </Backdrop >
  );
};

export default UnfollowPopup;

const UnFollowButton = styled(Button)({
  height: "52px",
  maxWidth: "83vw",
  margin: "1.5rem 0",
  borderRadius: "38px",
  background: colors.purpleGradient,
  border: `1px solid ${colors.purple}`,
  color: "white",
  ":hover": { border: `1px solid ${colors.purple}` }
});
